import React, { useState, useRef, useEffect, useContext } from 'react';
import { User, Camera, Phone, MapPin, Mail, Server } from 'lucide-react';
import './Profile.css';
import useApi from '../../../../utils/api-manager/Helper/useApi';
import AuthContext from '../../../../utils/secure-route/AuthContext';

const Profile = ({
  onProfileUpdate,
  onClose,
  currentUser,
  initialProfileData,
}) => {
  const { user } = useContext(AuthContext);
  const storeId = user?.store;
  const userId = user?.user_id
  const { Post } = useApi();
  const modalRef = useRef(null);
  const checkUserTypeData = localStorage.getItem("cache_2_checkUserType");
const parsedUser = checkUserTypeData ? JSON.parse(checkUserTypeData) : {};
const fullName = `${parsedUser.first_name || ''} ${parsedUser.last_name || ''}`.trim();

  console.log(currentUser.name);
  const [profileData, setProfileData] = useState(initialProfileData || {
    user_name: fullName,
    phone: '',
    location: '',
    bio: '',
    avatar: '',
  });

 const [emailSettings, setEmailSettings] = useState({
  store: user?.store || '', 
  user_id: user?.user_id || '',
  user_name: fullName || '',
  smtp_email: '',
  smtp_host: 'smtp.hostinger.com',
  smtp_port: '587',
  smtp_password: '',
  imap_host: 'imap.hostinger.com',
  imap_port: '993',
  pop3_host: 'pop.hostinger.com',
  pop3_port: '995',
});

  console.log("storeId" , storeId);
  console.log("userId" ,  user.user_id)

  const [errors, setErrors] = useState({});
  const [emailErrors, setEmailErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState('profileDetails');

useEffect(() => {
  if (currentUser && currentUser.name) {
    setProfileData(prev => ({
      ...prev,
      user_name: currentUser.name
    }));

    setEmailSettings(prev => ({
      ...prev,
      user_name: currentUser.name
    }));
  }
}, [currentUser]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const validateProfileForm = () => {
    const newErrors = {};
    if (!profileData.user_name.trim()) newErrors.user_name = 'Username is required';
    if (profileData.phone && !/^\+?[\d\s\-\(\)]+$/.test(profileData.phone)) {
      newErrors.phone = 'Phone number is invalid';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const validateEmailForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailSettings.smtp_email.trim()) {
      newErrors.smtp_email = 'Email is required';
    } else if (!emailRegex.test(emailSettings.smtp_email)) {
      newErrors.smtp_email = 'Please enter a valid email address';
    }

    if (!emailSettings.smtp_host.trim()) newErrors.smtp_host = 'SMTP Host is required';
    if (!emailSettings.smtp_port) {
      newErrors.smtp_port = 'SMTP Port is required';
    } else if (emailSettings.smtp_port < 1 || emailSettings.smtp_port > 65535) {
      newErrors.smtp_port = 'Port must be between 1 and 65535';
    }

    if (!emailSettings.smtp_password.trim()) newErrors.smtp_password = 'SMTP Password is required';

    if (!emailSettings.imap_host.trim()) newErrors.imap_host = 'IMAP Host is required';
    if (!emailSettings.imap_port) {
      newErrors.imap_port = 'IMAP Port is required';
    } else if (emailSettings.imap_port < 1 || emailSettings.imap_port > 65535) {
      newErrors.imap_port = 'Port must be between 1 and 65535';
    }

    if (!emailSettings.pop3_host.trim()) newErrors.pop3_host = 'POP3 Host is required';
    if (!emailSettings.pop3_port) {
      newErrors.pop3_port = 'POP3 Port is required';
    } else if (emailSettings.pop3_port < 1 || emailSettings.pop3_port > 65535) {
      newErrors.pop3_port = 'Port must be between 1 and 65535';
    }

    setEmailErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

 const handleProfileChange = (e) => {
  const { name, value } = e.target;
  setProfileData(prev => ({ ...prev, [name]: value }));
  if (name === 'user_name') {
    setEmailSettings(prev => ({ ...prev, user_name: value }));
  }
};

  const handleEmailChange = (e) => {
    const { name, value } = e.target;
    setEmailSettings(prev => ({ ...prev, [name]: value }));
  };

  const handleAvatarChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size > 5 * 1024 * 1024) {
        setErrors(prev => ({ ...prev, avatar: 'File size must be less than 5MB' }));
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        setProfileData(prev => ({ ...prev, avatar: e.target.result }));
        setErrors(prev => {
          const copy = { ...prev };
          delete copy.avatar;
          return copy;
        });
      };
      reader.readAsDataURL(file);
    }
  };

  const handleProfileSave = async () => {
    if (!validateProfileForm()) return;
    setIsLoading(true);
    await new Promise((r) => setTimeout(r, 1000));
    onProfileUpdate(profileData);
    setIsLoading(false);
    onClose();
  };

  const handleEmailSave = async () => {
    if (!validateEmailForm()) return;
    setIsLoading(true);
    try {
      const response = await Post('userSmtpSetting', emailSettings);
      console.log('Saved:', response.data);
      onClose();
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const renderEmailSettings = () => (
    <div className="uprf-settings-form">
      <div className="uprf-section-title">
        <Mail size={20} />
        <h6>Email Configuration</h6>
      </div>

      <div className="uprf-config-section">
        <h7>Email Account</h7>
        <div className="uprf-input-group">
          <label><Mail size={16} /> Email Address *</label>
          <input
            type="email"
            name="smtp_email"
            value={emailSettings.smtp_email}
            onChange={handleEmailChange}
            placeholder="user@example.com"
            className={emailErrors.smtp_email ? 'uprf-input-error' : ''}
          />
          {emailErrors.smtp_email && <div className="uprf-error-text">{emailErrors.smtp_email}</div>}
        </div>
      </div>

      <div className="uprf-config-section">
        <h7>SMTP Settings (Outgoing Mail)</h7>
        <div className="uprf-input-grid">
          <div className="uprf-input-group">
            <label><Server size={16} /> SMTP Host *</label>
            <input
              type="text"
              name="smtp_host"
              value={emailSettings.smtp_host}
              onChange={handleEmailChange}
              className={emailErrors.smtp_host ? 'uprf-input-error' : ''}
            />
            {emailErrors.smtp_host && <div className="uprf-error-text">{emailErrors.smtp_host}</div>}
          </div>
          <div className="uprf-input-group">
            <label>SMTP Port *</label>
            <input
              type="number"
              name="smtp_port"
              value={emailSettings.smtp_port}
              onChange={handleEmailChange}
              className={emailErrors.smtp_port ? 'uprf-input-error' : ''}
            />
            {emailErrors.smtp_port && <div className="uprf-error-text">{emailErrors.smtp_port}</div>}
          </div>
        </div>
        <div className="uprf-input-group">
          <label>SMTP Password *</label>
          <input
            type="password"
            name="smtp_password"
            value={emailSettings.smtp_password}
            onChange={handleEmailChange}
            className={emailErrors.smtp_password ? 'uprf-input-error' : ''}
          />
          {emailErrors.smtp_password && <div className="uprf-error-text">{emailErrors.smtp_password}</div>}
        </div>
      </div>

      <div className="uprf-config-section">
        <h7>IMAP Settings (Incoming Mail)</h7>
        <div className="uprf-input-grid">
          <div className="uprf-input-group">
            <label><Server size={16} /> IMAP Host *</label>
            <input
              type="text"
              name="imap_host"
              value={emailSettings.imap_host}
              onChange={handleEmailChange}
              className={emailErrors.imap_host ? 'uprf-input-error' : ''}
            />
            {emailErrors.imap_host && <div className="uprf-error-text">{emailErrors.imap_host}</div>}
          </div>
          <div className="uprf-input-group">
            <label>IMAP Port *</label>
            <input
              type="number"
              name="imap_port"
              value={emailSettings.imap_port}
              onChange={handleEmailChange}
              className={emailErrors.imap_port ? 'uprf-input-error' : ''}
            />
            {emailErrors.imap_port && <div className="uprf-error-text">{emailErrors.imap_port}</div>}
          </div>
        </div>
      </div>

      <div className="uprf-config-section">
        <h7>POP3 Settings (Alternative Incoming Mail)</h7>
        <div className="uprf-input-grid">
          <div className="uprf-input-group">
            <label><Server size={16} /> POP3 Host *</label>
            <input
              type="text"
              name="pop3_host"
              value={emailSettings.pop3_host}
              onChange={handleEmailChange}
              className={emailErrors.pop3_host ? 'uprf-input-error' : ''}
            />
            {emailErrors.pop3_host && <div className="uprf-error-text">{emailErrors.pop3_host}</div>}
          </div>
          <div className="uprf-input-group">
            <label>POP3 Port *</label>
            <input
              type="number"
              name="pop3_port"
              value={emailSettings.pop3_port}
              onChange={handleEmailChange}
              className={emailErrors.pop3_port ? 'uprf-input-error' : ''}
            />
            {emailErrors.pop3_port && <div className="uprf-error-text">{emailErrors.pop3_port}</div>}
          </div>
        </div>
      </div>

      <div className="uprf-button-group">
        <button className="uprf-cancel-button" onClick={onClose} disabled={isLoading} type="button">Cancel</button>
        <button className="uprf-save-button" onClick={handleEmailSave} disabled={isLoading} type="button">
          {isLoading ? (<><div className="uprf-loading-spinner"></div> Saving...</>) : 'Save Email Settings'}
        </button>
      </div>
    </div>
  );

  const renderProfileDetails = () => (
    <div className="uprf-settings-form">
      <div className="uprf-avatar-container">
        <div className="uprf-avatar-wrapper">
          {profileData.avatar ? (
            <img src={profileData.avatar} alt="Profile" className="uprf-avatar-image" />
          ) : (
            <div className="uprf-avatar-image">
              {profileData.user_name ? profileData.user_name.charAt(0).toUpperCase() : "?"}
            </div>
          )}
        </div>
        <div className="uprf-avatar-controls">
          <input
            type="file"
            id="avatar-upload"
            accept="image/*"
            onChange={handleAvatarChange}
            style={{ display: 'none' }}
          />
          <label htmlFor="avatar-upload" className="uprf-avatar-button" style={{ cursor: 'pointer' }}>
            <Camera size={16} /> Change Photo
          </label>
          {errors.avatar && <div className="uprf-error-text">{errors.avatar}</div>}
        </div>
      </div>

      <div className="uprf-input-grid">
        <div className="uprf-input-group">
          <label><User size={16} /> Username *</label>
          <input
            type="text"
            name="user_name"
            value={profileData.user_name}
            onChange={handleProfileChange}
            placeholder="sonali"
            className={errors.user_name ? 'uprf-input-error' : ''}
          />
          {errors.user_name && <div className="uprf-error-text">{errors.user_name}</div>}
        </div>

        <div className="uprf-input-group">
          <label><Phone size={16} /> Phone Number</label>
          <input
            type="tel"
            name="phone"
            value={profileData.phone}
            onChange={handleProfileChange}
            placeholder="+1 (555) 123-4567"
            className={errors.phone ? 'uprf-input-error' : ''}
          />
          {errors.phone && <div className="uprf-error-text">{errors.phone}</div>}
        </div>

        <div className="uprf-input-group uprf-full-width">
          <label><MapPin size={16} /> Location</label>
          <input
            type="text"
            name="location"
            value={profileData.location}
            onChange={handleProfileChange}
            placeholder="City, Country"
          />
        </div>
      </div>

      <div className="uprf-input-group">
        <label><User size={16} /> Bio</label>
        <textarea
          name="bio"
          value={profileData.bio}
          onChange={handleProfileChange}
          placeholder="Tell us about yourself..."
          rows="4"
        />
      </div>

      <div className="uprf-button-group">
        <button className="uprf-cancel-button" onClick={onClose} disabled={isLoading} type="button">Cancel</button>
        <button className="uprf-save-button" onClick={handleProfileSave} disabled={isLoading} type="button">
          {isLoading ? (<><div className="uprf-loading-spinner"></div> Saving...</>) : 'Save Profile'}
        </button>
      </div>
    </div>
  );

  return (
    <div style={{
      position: "fixed",
      top: 0, left: 0, right: 0, bottom: 0,
      background: "rgba(0, 0, 0, 0.4)",
      backdropFilter: "blur(8px)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 1000,
      animation: "uprfFadeIn 0.3s ease-out"
    }}>
      <div className="uprf-modal-container" ref={modalRef}>
        <div className="uprf-modal-header">
          <div className="uprf-header-content">
            <h5>Profile Settings</h5>
          </div>
          <div className="uprf-header-actions">
            <button className="uprf-close-button" onClick={onClose} type="button" title="Close">✕</button>
          </div>
        </div>

        <div className="uprf-tab-navigation">
          <button
            className={activeTab === 'profileDetails' ? 'uprf-nav-tab uprf-tab-active' : 'uprf-nav-tab'}
            onClick={() => setActiveTab('profileDetails')}
          >
            <User size={14} /> Profile
          </button>
          <button
            className={activeTab === 'emailSettings' ? 'uprf-nav-tab uprf-tab-active' : 'uprf-nav-tab'}
            onClick={() => setActiveTab('emailSettings')}
          >
            <Mail size={14} /> Email Settings
          </button>
        </div>

        <div className="uprf-modal-body">
          {activeTab === 'profileDetails' ? renderProfileDetails() : renderEmailSettings()}
        </div>
      </div>
    </div>
  );
};

export default Profile;